import createCtx from "@tiny/components/src/utils/createContext";

interface PredefinedSegmentsContextProps {
  isDisabled: boolean;
  isRecommended: boolean;
}

const [usePredefinedSegmentsContext, PredefinedSegmentsProvider] =
  createCtx<PredefinedSegmentsContextProps>();

export { usePredefinedSegmentsContext, PredefinedSegmentsProvider };
